import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MsalService } from '@azure/msal-angular';
import { EndSessionRequest } from '@azure/msal-browser';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatBadgeModule,
    MatDividerModule
  ],
  templateUrl: './header.html',
  styleUrls: ['./header.scss']
})
export class HeaderComponent {
  isExpanded: boolean = false;

  constructor(
    private authService: MsalService,
    public route: ActivatedRoute
  ) {}
  // @Output() toggleSidebar = new EventEmitter<void>();
  @Output() toggleSidenav = new EventEmitter<boolean>();

  userName = 'Carlos Silva Santos';
  notificationCount = 3;

  // onToggleSidebar(): void {
  //   this.toggleSidebar.emit();
  // }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.toggleSidenav.emit(this.isExpanded);
  }

  onLogout(): void {
    this.authService.logout();
  }
}

